import { ReactElement, ReactNode } from 'react';
import { ImportFromDocumentationDialog } from './ImportFromDocumentationDialog';
import { ImportFromDocumentationProvider } from './ImportFromDocumentationContext';

/**
 * Mount point for import-from-documentation (provider + dialog).
 *
 * Issue-only: requires `withIssue` and issue route/store for import.
 * Do not mount on inspection/template views — same scope as export (PT-7064).
 *
 * Gallery uses `useImportFromDocumentationOptional()`; without this provider the
 * import action is hidden.
 */
export function WithImportFromDocumentation({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  return (
    <ImportFromDocumentationProvider>
      {children}
      <ImportFromDocumentationDialog />
    </ImportFromDocumentationProvider>
  );
}
